export default "__VITE_ASSET__B6W17cUK__"